import React from 'react';
import { createUseStyles } from 'react-jss';

const useStyles = createUseStyles({
  root: {
    '@media (max-width: 1023px)': {
      minHeight: 'calc(100dvh - 260px)',
    },
  },
});

const FormLayout = ({ children }) => {
  const classes = useStyles();

  return (
    <div className={`gst-flex gst-flex-col gst-flex-1 lg:gst-flex-initial ${classes.root}`}>
      {children}
    </div>
  );
};

export default FormLayout;
